import { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import ScrollToTop from './ScrollToTop';

const Home = lazy(() => import('./Home'));
const Team = lazy(() => import('./Company/Team'));
const Spaces365 = lazy(() => import('./Spaces365'));
const BookDemo = lazy(() => import('./BookDemo/BookDemo'));
const HDRender = lazy(() => import('./HDRender'));
const SolutionsUseCases = lazy(() => import('./SolutionsUseCases'));
const CSuite = lazy(() => import('./CSuite'));
const PricePage = lazy(() => import('./Pricing'));
const WhitepaperPage = lazy(() => import('./Whitepaper/WhitepaperPage'));
const Demos = lazy(() => import('./Demos'));

const Pages = () => {
  return (
    <>
      <ScrollToTop />
      <Suspense fallback={<div className="loading-fallback">Loading...</div>}>
        <Routes>
          <Route
            path="/"
            element={<Home />}
          />
          <Route
            path="/team"
            element={<Team />}
          />
          <Route
            path="/team/"
            element={<Team />}
          />
          <Route
            path="/spaces365-platform"
            element={<Spaces365 />}
          />
          <Route
            path="/spaces365-platform/"
            element={<Spaces365 />}
          />
          <Route
            path="/book-demo"
            element={<BookDemo />}
          />
          <Route
            path="/book-demo/"
            element={<BookDemo />}
          />
          <Route
            path="/hd-render"
            element={<HDRender />}
          />
          <Route
            path="/hd-render/"
            element={<HDRender />}
          />
          <Route
            path="/solutions-use-cases"
            element={<SolutionsUseCases />}
          />
          <Route
            path="/solutions-use-cases/"
            element={<SolutionsUseCases />}
          />
          <Route
            path="/c-suite"
            element={<CSuite />}
          />
          <Route
            path="/c-suite/"
            element={<CSuite />}
          />
          <Route
            path="/pricing"
            element={<PricePage />}
          />
          <Route
            path="/pricing/"
            element={<PricePage />}
          />
          <Route
            path="/executive-brief"
            element={<WhitepaperPage />}
          />
          <Route
            path="/executive-brief/"
            element={<WhitepaperPage />}
          />
          <Route
            path="/demos"
            element={<Demos />}
          />
          <Route
            path="/demos/"
            element={<Demos />}
          />

        </Routes>
      </Suspense>
    </>
  );
};

export default Pages;
